import React from 'react';
import { useTranslation } from "react-i18next";
import ReportPage from '../ReportChart/ReportPage';
import { Apis } from "services/api";
import { getDefectsBySystem } from "services/analytics";
import useChartColors from '../ReportChart/hooks/useChartColors';

const DefectsSystemReport = () => {
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const { getAllColors } = useChartColors();
  const { t } = useTranslation();

  const chartConfig = {
    id: 'defects-by-system',
    title: t("title.entityBySystem", { entity: customCaptions?.defectPlural, system: customCaptions?.system || 'System' }),
    fetchData: async (params) => {
      return await getDefectsBySystem(params);
    },
    allowedChartTypes: ['tree-map', 'pie', 'vertical-bar'],
    defaultChartType: 'tree-map',
    axisConfig: {
      categoryAxis: { dataKey: 'label' },
      valueAxes: [{ 
        label: t("label.count")
      }]
    },
    series: [
      { 
        label: t("label.count"),
        key: 'count', 
        showLegend: false,
        colors: getAllColors()
      }
    ],
    transformData: (response) => {
      return response?.data?.data;
    },
    filters: {
      timeframe: {
        allowCustomRange: true,
        defaultRange: 'show-all',
      },
      department: { multiSelect: true },
      model: true,
      riskRatings: true
    },
    viewData: '/app/defects',
    itemNavigation: true,
    drilldown: {
      defaultChartType: 'tree-map',
      allowedChartTypes: ['tree-map', 'pie', 'vertical-bar'],
      axisConfig: {
        categoryAxis: { dataKey: 'label' },
        valueAxes: [{ 
          label: t("label.count") 
        }]
      },
      series: [
        { 
          label: t("label.count"),
          key: 'count', 
          showLegend: false,
          colors: getAllColors()
        }
      ],
      currentDrilldownLabel: `${customCaptions?.asset || 'Asset'}`,
      getParams: (dataPoint) => {
        return {
          defectSystemId: dataPoint.id,
          defectSystem: {
            id: dataPoint.id,
            name: dataPoint.name || "Show All"
          }
        };
      }
    }
  };

  return (
    <ReportPage 
      title={t("title.entityBySystem", { entity: customCaptions?.defectPlural, system: customCaptions?.system || 'System' })}
      chartConfig={chartConfig}
    />
  );
};

export default DefectsSystemReport; 
